import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import ReactModal from 'react-modal';
import cn from 'classnames';
import { applyClasses, applyProps } from '../../shared/js';
import PropTypes from 'prop-types';

import styles from './overlay-spinner.module.scss';

const QuoteLoadingBlocker = ({ loading, ...props }) => {
  const { formatMessage } = useIntl();
  const [hide, setHide] = useState(false);
  const handleAnimationEnd = () => {
    if (loading) return;
    setHide(true);
  };
  useEffect(() => {
    if (loading) setHide(false);
  }, [loading]);

  return (
    <ReactModal
      // eslint-disable-next-line react/prop-types
      className={cn(props.className, { [styles.open]: loading })}
      overlayClassName={styles.overlay}
      isOpen={loading}
      appElement={document.getElementById('root')}
      closeTimeoutMS={300}
    >
      <div
        className={cn(
          styles.spinner,
          props.className,
          { [styles.loading]: loading, [styles.hide]: hide },
          applyClasses(props, styles)
        )}
        {...applyProps(props)}
        onAnimationEnd={handleAnimationEnd}
      >
        <div
          className={styles.cssSpinner}
          aria-label={formatMessage({
            id: 'accessibility.loading',
            defaultMessage: 'loading',
          })}
        />
      </div>
    </ReactModal>
  );
};

QuoteLoadingBlocker.propTypes = {
  /** Whether or not the loader is active */
  loading: PropTypes.bool,
  /** A class name forwarded to the parent overlay component */
  className: PropTypes.string,
};

QuoteLoadingBlocker.defaultProps = {
  loading: undefined,
  className: '',
};

export default QuoteLoadingBlocker;
